export type TimeOffType = "vacation" | "sick" | "personal";
export type DayPart = "full" | "half-am" | "half-pm";
export type RequestStatus = "pending" | "approved" | "denied" | "cancelled";

export const TIME_OFF_TYPES: Record<
  TimeOffType,
  { label: string; needsApproval: boolean; forecastCategory: string; color: string }
> = {
  vacation: { label: "Vacation", needsApproval: true, forecastCategory: "Vacation", color: "var(--brand-cyan)" },
  sick: { label: "Sick Time", needsApproval: false, forecastCategory: "Sick Time", color: "var(--success)" },
  personal: {
    label: "Other Time Off",
    needsApproval: true,
    forecastCategory: "Other Time Off",
    color: "var(--brand-purple)",
  },
};
